import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { YesNoBadge } from '../../../components/YesNoBadge'
import { OrderOriginInfoDto } from '../../../interfaces/OrderOrigin/OrderOrigin'
import { utcToLocal } from '../../../utils/dateHelper'

export const getColumnsConfig = (): TableColumn<OrderOriginInfoDto>[] => [
  { key: 'orderOriginId', title: 'ID'},
  { key: 'origin', title: 'Canal de Venta'},
  {
    key: 'lastModifiedAt',
    title: 'Fecha modificación',
    render: (value: unknown) => utcToLocal(value as string, 'dd/MM/yyyy')
  },
  {
    key: 'active',
    title: 'Activo',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
